export default __webpack_public_path__ + "static/media/product-17 (2).dc22fd7a.jpg";